// actions/accountActions.js
export const FETCH_ACCOUNT_INFO_REQUEST = 'FETCH_ACCOUNT_INFO_REQUEST';
export const FETCH_ACCOUNT_INFO_SUCCESS = 'FETCH_ACCOUNT_INFO_SUCCESS';
export const FETCH_ACCOUNT_INFO_FAILURE = 'FETCH_ACCOUNT_INFO_FAILURE';

export const FETCH_ACCOUNT_DETAILS_REQUEST = 'FETCH_ACCOUNT_DETAILS_REQUEST';
export const FETCH_ACCOUNT_DETAILS_SUCCESS = 'FETCH_ACCOUNT_DETAILS_SUCCESS';
export const FETCH_ACCOUNT_DETAILS_FAILURE = 'FETCH_ACCOUNT_DETAILS_FAILURE';


export const fetchAccountInfoRequest = (obj) => {
  return{
  type: FETCH_ACCOUNT_INFO_REQUEST,
  payload: obj
}};

export const fetchAccountInfoSuccess = (accountInfo) => ({
  type: FETCH_ACCOUNT_INFO_SUCCESS,
  payload: accountInfo
});

export const fetchAccountInfoFailure = (error) => ({
  type: FETCH_ACCOUNT_INFO_FAILURE,
  payload: error
});

export const fetchAccountDetailsRequest = (accountId, accountName, clientName) => ({
  type: FETCH_ACCOUNT_DETAILS_REQUEST,
  payload: { accountId, accountName, clientName }
});

export const fetchAccountDetailsSuccess = (accountDetails) => ({
  type: FETCH_ACCOUNT_DETAILS_SUCCESS,
  payload: accountDetails
});

export const fetchAccountDetailsFailure = (error) => ({
  type: FETCH_ACCOUNT_DETAILS_FAILURE,
  payload: error
});